import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import CreditTab from "../CreditTab";
import * as services from "../../../store/service";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../../store";
import { IBusinessProfileResponse } from "../../../store/businessProfileService/types";
import * as BusinessProfileActions from "../../../store/businessProfileService/actions";
import * as ConfigurationActions from "../../../store/configurationService/actions";
import { stateList } from "../../../util/CommonLists";
import { useForm } from "react-hook-form";
import { PATTERNS } from "../../../util/patterns";
import { Select } from "antd";

interface ICompanyInformation {
    CompanyId: string;
    Name: string;
    Address: string;
    City: string;
    State: string;
    Zip: string;
    PhoneNumber: string;
    CreditSafeNumber: string;
    DUNSNumber: string;
    CreditProvider: string;
    Detail: string;
}
interface ISearchQuery {
    CompanyId: string;
    Name: string;
    Address: string;
    City: string;
    State: any;
    Zip: string;
    PhoneNumber: string;
    CreditSafeNumber: string;
    DUNSNumber: string;
    CreditProvider: string;
    SearchLimit: string;
    RegistrationNumber?: string;
}
const BusinessSearch = (props: any) => {
    const query = new URLSearchParams(props.location.search);
    const dispatch = useDispatch();
    const requestBusinessProfile = (profile: IBusinessProfileResponse) => dispatch(BusinessProfileActions.actionCreators.requestBusinessProfile(profile));
    const businessProfileStatus = useSelector(
        (state: ApplicationState) =>
            state.loggedInUser &&
            state.loggedInUser.userServiceDetails?.businessProfileStatus?.filter((obj: any) => {
                return obj.provider;
            })
    );
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));
    const creditProvider = businessProfileStatus != null && businessProfileStatus.length > 0 ? businessProfileStatus[0].provider : "";
    const [loading, setLoading] = useState(false);
    const [selectedTab, setSelectedTab] = useState("0");
    const [loadingContact, setLoadingContact] = useState(false);
    const [isCompanyNameBlank, setIsCompanyNameBlank] = useState(true);
    const [businessProfiles, setBusinessProfiles] = useState([] as ICompanyInformation[]);
    const [searchQuery, setSearchQuery] = useState<ISearchQuery>({
        CompanyId: "",
        Name: "",
        Address: "",
        City: "",
        State: "",
        Zip: "",
        PhoneNumber: "",
        CreditSafeNumber: "",
        DUNSNumber: "",
        CreditProvider: "",
        SearchLimit: "",
        RegistrationNumber: "",
    });

    const { register, handleSubmit, errors, setValue } = useForm({
        mode: "onSubmit",
        reValidateMode: "onChange",
    });

    const searchBusinessProfile = (data: any) => {
        const getQuery: any = {
            SearchLimit: "10",
            RegistrationNumber: data.companyName,
            Name: data.businessName,
            Address: searchQuery.Address,
            City: data.businessCity,
            State: data.businessState,
            Zip: searchQuery.Zip,
            PhoneNumber: searchQuery.PhoneNumber,
            CreditProvider: creditProvider,
        };
        setLoading(true);
        searchBusinessFromQuery(getQuery);
    };

    const searchBusinessFromQuery = (query: ISearchQuery) => {
        let tempCompArray: ICompanyInformation[] = [];
        services.SearchCompany(query).then((companyInformationArray: any) => {
            if (companyInformationArray?.Companies?.length > 0) {
                companyInformationArray.Companies.forEach((companyInformation: any) => {
                    var companyInfo = {} as ICompanyInformation;
                    companyInfo.Address = companyInformation.Address;
                    companyInfo.City = companyInformation.City;
                    companyInfo.CompanyId = companyInformation.Id;
                    companyInfo.CreditProvider = query.CreditProvider;
                    companyInfo.Detail = companyInformation.Details;
                    companyInfo.Name = companyInformation.Name;
                    companyInfo.PhoneNumber = companyInformation.PhoneNumber;
                    companyInfo.State = companyInformation.State;
                    companyInfo.Zip = companyInformation.Zip;
                    tempCompArray.push(companyInfo);
                });
            }
            setBusinessProfiles(tempCompArray);
            setLoading(false);
        });
    };

    const ensureDataFetched = () => {
        const tmpselectedTab = query.get("selectedTab");
        if (tmpselectedTab != null) {
            setSelectedTab(tmpselectedTab);
        }
        setLoading(true);
        setLoadingContact(true);

        services.getSmbContactInfo().then((data: any) => {
            const creditProvider = businessProfileStatus != null && businessProfileStatus.length > 0 ? businessProfileStatus[0].provider : "";
            if (data) {
                let query = {
                    SearchLimit: "10",
                    Name: data?.businessName,
                    Address: data?.address1,
                    City: data?.city,
                    State: data?.state,
                    Zip: data?.zipCode,
                    PhoneNumber: data?.phone,
                    CreditProvider: creditProvider,
                    RegistrationNumber: "",
                } as ISearchQuery;
                setLoadingContact(false);
                setSearchQuery(query);
                searchBusinessFromQuery(query);
            }
        });
    };

    const setUserBusinessProfile = (profile: ICompanyInformation) => {
        requestBusinessProfile(profile);
        if (selectedTab === "0") {
            props.history.push("/bcredit/get-started");
        } else {
            props.history.push("/bcredit/get-started?selectedTab=" + selectedTab);
        }
    };

    useEffect(() => {
        ensureDataFetched();
    }, []);

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    return (
        <React.Fragment>
            <div className=" row between-xs middle-xs">
                <div className="col-xs">
                    <h1 className="title-page" id="title-page" tabIndex={-1}>
                        Credit
                    </h1>
                </div>
                <div className="col-xs flex-grow-null">
                    {selectedTab === "0" && (
                        <button
                            type="button"
                            className="btn-default btn-primary-outline btn-no-border btn-no-padding btn-icon-only"
                            onClick={() => props.history.push("/dashboard")}
                        >
                            <span className="btn-icon">
                                <em className="las la-times"></em>
                            </span>
                            <span className="btn-text">Cancel</span>
                        </button>
                    )}
                </div>
            </div>

            {selectedTab !== "0" && <CreditTab selectedTab={selectedTab} />}

            <div className="row" id="content">
                <div className="col-xs-12">
                    <div className="box offset-padding">
                        <div className="box-header">
                            <div className="box-title-container">
                                <div className="box-title-icon" aria-hidden="true">
                                    <em className="las la-search"></em>
                                </div>
                                <div className="box-title-text has-actions">
                                    <h2 className="box-title">Search for My Business</h2>
                                </div>
                            </div>
                            <div className="box-description">
                                <p>
                                    Find and link your Business Credit Profile by completing the search form below.
                                    <br />
                                    {selectedTab === "0" ? (
                                        <span onClick={() => props.history.push("/bcredit/credit-profile-setup")}>
                                            <a href="#" onClick={(e) => e.preventDefault()} className="default_link">
                                                If you are unable to find your business, fill out this form
                                            </a>
                                        </span>
                                    ) : (
                                        <span onClick={() => props.history.push("/bcredit/credit-profile-setup?selectedTab=" + selectedTab)}>
                                                <a href="#" onClick={(e) => e.preventDefault()} className="default_link">
                                                If you are unable to find your business, fill out this form
                                            </a>
                                        </span>
                                    )}
                                    &nbsp;so we can verify your Business Credit Profile.
                                </p>
                            </div>
                        </div>
                        <div className="box-content">
                            <form
                                id="form-search-business-credit-profile"
                                className={loadingContact ? "box loading" : ""}
                                onSubmit={handleSubmit(searchBusinessProfile)}
                            >
                                <div className="form-row inline row">
                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                        {creditProvider != null && creditProvider === "CREDITSAFE" && (
                                            <label htmlFor="company-name-label">
                                                Company Name <br />
                                                <small>(SOS Charter Number OR Tax-ID)</small>
                                            </label>
                                        )}
                                        {creditProvider != null && creditProvider === "DUNBRADSTREET" && <label htmlFor="company-name-label">D-U-N-S Number</label>}
                                    </div>
                                    <div className="form-input col-xs-12 col-sm-4 col-no-gutter">
                                        <input
                                            type="text"
                                            className="inputbox"
                                            name="companyName"
                                            id="company-name-label"
                                            defaultValue={searchQuery.RegistrationNumber}
                                            ref={register({ required: !isCompanyNameBlank })}
                                            onChange={(e) => {
                                                setValue("businessName", "");
                                                setValue("businessCity", "");
                                                setValue("businessState", "---");
                                                if (e.target.value && e.target.value !== "") {
                                                    setIsCompanyNameBlank(false);
                                                } else {
                                                    setIsCompanyNameBlank(true);
                                                }
                                            }}
                                        />
                                    </div>
                                </div>

                                <div className="margin-vertical-s">- OR -</div>

                                <div className="form-row inline row">
                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                        <label htmlFor="business-name-label">Business Name</label>
                                    </div>
                                    <div className="form-input col-xs-12 col-sm-4 col-no-gutter">
                                        <input
                                            type="text"
                                            className="inputbox"
                                            defaultValue={searchQuery.Name}
                                            id="business-name-label"
                                            name="businessName"
                                            ref={register({ required: isCompanyNameBlank, pattern: PATTERNS.BUSINESSNAME.pattern })}
                                            onChange={(e) => {
                                                setValue("companyName", "");
                                                setIsCompanyNameBlank(true);
                                            }}
                                        />
                                        {errors["businessName"] && errors["businessName"].type === "required" && (
                                            <span className="form-error">Business Name is required</span>
                                        )}
                                        {errors["businessName"] && errors["businessName"].type === "pattern" && (
                                            <span className="form-error">{PATTERNS.BUSINESSNAME.message}</span>
                                        )}
                                    </div>
                                </div>

                                <div className="form-row inline row">
                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                        <label htmlFor="city-name-label">City</label>
                                    </div>
                                    <div className={`form-input col-xs-12 col-sm-4 col-no-gutter ${errors["businessCity"] && "status-error"}`}>
                                        <input
                                            type="text"
                                            defaultValue={searchQuery.City}
                                            className="inputbox"
                                            name="businessCity"
                                            id="city-name-label"
                                            ref={register({ required: isCompanyNameBlank, pattern: PATTERNS.CITY.pattern })}
                                            onChange={(e) => {
                                                setValue("companyName", "");
                                                setIsCompanyNameBlank(true);
                                            }}
                                        />
                                        {errors["businessCity"] && errors["businessCity"].type === "required" && (
                                            <span className="form-error">City is required</span>
                                        )}
                                        {errors["businessCity"] && errors["businessCity"].type === "pattern" && (
                                            <span className="form-error">{PATTERNS.CITY.message}</span>
                                        )}
                                    </div>
                                </div>

                                <div className="form-row inline row ">
                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                        <label htmlFor="state-label">State</label>
                                    </div>
                                    <div className="form-input col-xs-12 col-sm-2 col-no-gutter">
                                        <select
                                            className="inputbox"
                                            id="state-label"
                                            name="businessState"
                                            defaultValue={searchQuery.State}
                                            ref={register({
                                                validate: {
                                                    required: (value) => {
                                                        if (value === "---" && isCompanyNameBlank) return "State is required.";
                                                        return true;
                                                    },
                                                },
                                            })}
                                            onChange={(e) => {
                                                setValue("companyName", "");
                                                setIsCompanyNameBlank(true);
                                            }}
                                        >
                                            {stateList.map((val: any, index: number) => (
                                                <option key={"state-" + index} value={val.value}>
                                                    {val.name}
                                                </option>
                                            ))}
                                        </select>
                                        {errors["businessState"] && <span className="form-error">State is required.</span>}
                                    </div>
                                </div>

                                <div className="margin-top-l"></div>

                                <button type="submit" className="btn-default btn-primary btn-min-width" id="btn-search-business">
                                    <span className="btn-text">Search</span>
                                </button>
                            </form>

                            <div id="business_search_results" className={loading ? "margin-top-xl margin-bottom-s box loading" : "margin-top-xl margin-bottom-s"}>
                                <h2 className="content-sub-title">Search Results</h2>

                                <div className="table-container scroll">
                                    <table className="m-table-generic">
                                        <caption className="sr-only">Search Results</caption>
                                        <thead>
                                            <tr>
                                                <th scope="col">Business Name</th>
                                                <th scope="col">Address</th>
                                                <th scope="col">Action</th>
                                            </tr>
                                        </thead>
                                        {businessProfiles.length !== 0 ? (
                                            <tbody>
                                                {businessProfiles &&
                                                    businessProfiles.map((profile, index: number) => (
                                                        <tr key={"profile-" + index}>
                                                            <th scope="row" className="table-label">
                                                                {profile.Name}
                                                            </th>

                                                            <td>{profile.Detail}</td>
                                                            <td>
                                                                <button
                                                                    type="button"
                                                                    className="btn-default btn-no-padding btn-no-border btn-link btn-table"
                                                                    onClick={() => setUserBusinessProfile(profile)}
                                                                >
                                                                    <span className="btn-text">
                                                                        Select <span className="sr-only">{profile.Name}</span>
                                                                    </span>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                            </tbody>
                                        ) : (
                                            <tbody className="ant-table-tbody">
                                                <tr>
                                                    <td colSpan={3}>
                                                        <div className="box">
                                                            <div className="box-content text-align-center">
                                                                There are no Business Credit Profile in your currently selected filter. Try updating your filter
                                                                criteria.
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        )}
                                    </table>
                                    <div className="container-border padding-vertical-s padding-horizontal-s margin-top-xl">
                                        <h3 className="content-sub-title">Not seeing your business in the search results?</h3>
                                        <p>
                                            Your company may not have a Business Credit Profile yet. We&apos;re here to take care of this for you. Complete the form
                                            and we will handle the rest!
                                        </p>
                                        {selectedTab === "0" ? (
                                            <NavLink to="/bcredit/credit-profile-setup" className="btn-default btn-primary margin-top-l">
                                                <span className="btn-text">Complete 2-Minute Form</span>
                                            </NavLink>
                                        ) : (
                                            <NavLink
                                                to={"/bcredit/credit-profile-setup?selectedTab=" + selectedTab}
                                                className="btn-default btn-primary margin-top-l"
                                            >
                                                <span className="btn-text">Complete 2-Minute Form</span>
                                            </NavLink>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default BusinessSearch;
